import { ReactNode } from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";

import { FileInput, FileInputProps } from "src/components/FileInput";

export type { FileInputProps };
export { FileInput };

// ============= RHF Field =============

export interface FileInputFieldProps<TForm extends FieldValues>
  extends Omit<FileInputProps, "value" | "onChange"> {
  name: Path<TForm>;
  control: Control<TForm, any, any>;
}

export function FileInputField<TForm extends FieldValues>({
  name,
  control,
  ...baseProps
}: FileInputFieldProps<TForm>): ReactNode {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FileInput
          {...baseProps}
          value={field.value ?? []}
          onChange={field.onChange}
          error={fieldState.error?.message}
        />
      )}
    />
  );
}
